import { fromPromise } from 'xstate';

import {
  type FetchOrdersOutput,
  type OrdersMachineContext,
  type OrderWithIdAndWantedTime,
} from '../orders-machine.types';

// ─────────────────────────────────────────────────────────────────────────────

export function createOrdersMachineActors<Order extends OrderWithIdAndWantedTime>() {
  const fetchOrders = fromPromise<FetchOrdersOutput<Order>, OrdersMachineContext<Order>>(
    async () => {
      throw new Error('`fetchOrders` actor is not provided.');
    },
  );

  return {
    fetchOrders,
  };
}
